<template>
  <el-row>
    <h1 class="title-text">Overview</h1>
    <el-col :span="24">
      <el-card shadow="never">
        <el-row>
          <el-tabs type="card" v-model="activeName" >
              <el-tab-pane v-for="item in listMenu" :key="item.id" class="tabLeadPool" :label="item.name" :name="String(item.id)"></el-tab-pane>
               <keep-alive>
                  <component v-bind:is="currentTabComponent"></component>
                </keep-alive>
          </el-tabs>
        </el-row>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
// import fgApi from '@/services/fillgoods'
import CustomerProfile from '@/components/Overview/CustomerProfile'
import BillingProfile from '@/components/Overview/BillingProfile'
import TransactionProfile from '@/components/Overview/TransactionProfile'
import SubscriptionProfile from '@/components/Overview/SubscriptionProfile'
export default {
    name: 'LeadPoolMain',
    components: {
        CustomerProfile,
        BillingProfile,
        TransactionProfile,
        SubscriptionProfile
    },
    data () {
        return {
            activeName: '0',
            listMenu: [
                // { id: 0, name: 'Approve' },
                { id: 0, name: 'Customer Profile', componentName: 'CustomerProfile' },
                { id: 1, name: 'Billing Profile', componentName: 'BillingProfile' },
                { id: 2, name: 'Transaction Profile', componentName: 'TransactionProfile' },
                { id: 3, name: 'Subscription Profile', componentName: 'SubscriptionProfile' }
            ]
        }
    },
    computed: {
        currentTabComponent: function () {
            return this.listMenu[this.activeName].componentName
        }
    },
    created () {},
    methods: {}
}
</script>
<style lang="scss" scoped>
.title-text{
  text-align: left;
}
.tabLeadPool{
  // .el-tabs__nav-scroll {
  //     background-color: black;
  // }
  .el-tabs__item{
      color: white !important;
       background-color: black;

  }
   .is-active{
      color: teal !important;
      background-color: white;
  }

}
</style>
